import { Provider } from "react-redux";
// import BlogData from "../../data/blog/blog.json";
import PageHead from "../Head";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import BlogList from "@/components/Blogs/BlogList";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import Banner from "@/components/Common/Banner";
import BackToTop from "../backToTop";
import CPStaticContent from '../../models/CPStaticContent.js'
import Instagram from "@/components/Instagram/Instagram";

const BlogListLayout = (post) => {

  const BlogData = {}
  BlogData['blogList'] = post.list
  // console.log(BlogData)

  // let getAllBlogs = JSON.parse(JSON.stringify(BlogData.blogList));
  let getAllBlogs = BlogData.blogList

  return (
    <>
      <PageHead title="Blogs" description="Blogs written by CloudPedia professionals" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <Banner
            col="col-lg-10 offset-lg-1"
            text="Blogs"
            getBlog={getAllBlogs}
            listType="Blogs"
          />
          <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <BlogList 
              isPagination={true}
              blogData={BlogData}
              blogType={"blog"} />
            </div>
          </div>

          <Instagram />
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default BlogListLayout;

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("blogs")
  await stContent.fetchContent()
  return await stContent.getListProps()
} 